<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/pay-conditions/table">账期列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium"
               style="width: auto">
            <el-form-item label="账期名称"
                          prop="name">
              <span>{{ form.name }}</span>
            </el-form-item>
            <el-form-item label="金蝶编码"
                          prop="kingdee_number">
              <span>{{ form.kingdee_number }}</span>
            </el-form-item>
            <el-form-item label="附件"
                          prop="attached_file">
              <template>
                <div class="view-navbar">
                  <ul class="clear-both">
                    <li v-for="(item, index) in form.attached_file"
                        :key="index">
                      <el-tooltip class="item"
                                  effect="dark"
                                  :content="item.name"
                                  placement="bottom">
                        <img v-if="item.type === 'pic'"
                             style="width: 100px; height: 100px"
                             :src="item.tmp_url"
                             @click="onViewImage">
                        <i v-else
                           class="sj-icon-pdf"
                           style=" font-size:100px; margin-top: 50px"
                           @click="onGetPdfFile(item, index)"></i>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
              </template>
            </el-form-item>

            <el-form-item label="日志"
                          prop="log">
              <template>
                <div v-for="(item, index) in form.log">
                  <span>{{ item.created_at }} {{ item.admin_name }}/{{ item.admin_id }} {{ item.desc }}</span>
                </div>
              </template>
            </el-form-item>

          </div>
        </div>
        <el-form-item>
          <el-button @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'

export default {
  components: {},
  data () {
    return {
      id: 0,
      form: {
        name: '',
        attached_file: [],
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getPayCondition', {id}).then(({data}) => {
        this.form = data
      })
    },
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '下载',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}
ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  overflow: hidden;
  padding: 1px 0;
}
li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/pay-conditions/pages/PayConditionsDetail.vue